import React from 'react';
import NewsletterSection from '../components/NewsletterSection';

const sdgGoals = [
  { num: 1, title: 'No Poverty', color: '#E5243B', desc: 'Economic empowerment programmes and skills training to break the cycle of poverty.', img: 'https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-01.jpg' },
  { num: 2, title: 'Zero Hunger', color: '#DDA63A', desc: 'Community food gardens and feeding schemes ensuring food security for vulnerable families.', img: 'https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-02.jpg' },
  { num: 3, title: 'Good Health', color: '#4C9F38', desc: 'Health screenings, wellness workshops, and mental health support for communities.', img: 'https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-03.jpg' },
  { num: 4, title: 'Quality Education', color: '#C5192D', desc: 'After-school programmes, tutoring, and adult literacy classes for lifelong learning.', img: 'https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-04.jpg' },
  // { num: 5, title: 'Gender Equality', color: '#FF3A21', desc: 'Women empowerment initiatives and gender-based violence awareness campaigns.', img: 'https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-05.jpg' },
  // { num: 8, title: 'Decent Work', color: '#A21942', desc: 'Youth entrepreneurship training and job readiness programmes for economic growth.', img: 'https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-08.jpg' },
  { num: 10, title: 'Reduced Inequality', color: '#DD1367', desc: 'Inclusive programmes ensuring equal access to opportunities regardless of background.', img: 'https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-10.jpg' },
  // { num: 11, title: 'Sustainable Cities', color: '#FD9D24', desc: 'Community development initiatives creating safer, more resilient neighbourhoods.', img: 'https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-11.jpg' },
  { num: 17, title: 'Partnerships', color: '#19486A', desc: 'Collaborating with government, NGOs, and corporates to amplify our impact.', img: 'https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-17.jpg' }
];

const SDGPage = () => (
  <>
    <section style={{ paddingTop: '120px', paddingBottom: '4rem', background: 'var(--off-white)' }}>
      <div className="container">
        <div className="section-header" style={{ marginBottom: '2rem' }}>
          <span className="section-tag">Global Goals</span>
          <h1>Sustainable Development Goals</h1>
          <p>Our work directly contributes to the United Nations Sustainable Development Goals, aligning local action with global impact.</p>
        </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
        <div className="grid grid-3" style={{ gap: '1.5rem' }}>
          {sdgGoals.map((sdg, i) => (
            <div key={i} className="scroll-animate card" style={{
              overflow: 'hidden', transitionDelay: `${i * 80}ms`
            }}>
              <img
                src={sdg.img}
                alt={`SDG ${sdg.num}: ${sdg.title}`}
                style={{ width: '100%', display: 'block' }}
              />
              <div style={{ padding: '1.5rem' }}>
                <p style={{ fontSize: '0.875rem' }}>{sdg.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <NewsletterSection />
  </>
);

export default SDGPage;
